import iconIMG from '../../assets/mileshow.svg';
import MyLogo from "./Logo.module.css";

const Logo = () => {

    return <img className={MyLogo.logo} alt='milegrid-logo' src={iconIMG}/>
};

export default Logo;